import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookie from 'docs/Cookie.vue'
import PrivacyPolicy from 'docs/PrivacyPolicy.vue'
import TermsConditions from 'docs/TermsConditions.vue'
import Contact from 'docs/Contact.vue'
import HearMore from 'docs/HearMore.vue'
import SiteMap from 'docs/Sitemap.vue'
import Statement from 'docs/Statement.vue'
import About from 'docs/About.vue'
import Home from 'home/Home.vue'
import Login from '../views/pages/account/UserLogin.vue'
import UserAccount from '../views/pages/account/UserAccount.vue'
import EditAccount from '../views/pages/account/EditUserAccount.vue'
import Reset from '../views/pages/account/ResetUserPassword.vue'
import ActivateAccount from '../views/pages/account/ActivateUserAccount.vue'
import ChangePassword from '../views/pages/account/ChangeUserPassword.vue'
import UserRecentSearches from '../views/pages/account/RecentUserSearches.vue'
import Register from '../views/pages/account/Register.vue'
import TMiddleware from '../middleware/tactran-middleware'
import JourneyViewedMiddleware from '../middleware/journey-viewed'
import Results from '../views/Results.vue'
import Journey from '../views/Journey.vue'
import PrintJourney from '../components/PrintJourney.vue'

Vue.use(VueRouter)

const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND]

const defaultRoutes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/search/:hash/results',
        name: 'Results',
        component: Results,
        meta: {
            breadcrumb: [
                { title: 'Plan your journey ', route: 'Home' },
                { title: 'Select journey option ', route: 'Results' },
            ],
        },
    },
    {
        path: '/search/:hash/results/:journeyId',
        name: 'Journey',
        component: Journey,
        meta: {
            breadcrumb: [
                { title: 'Plan your journey ', route: 'Home' },
                { title: 'Select journey option ', route: 'Results' },
                { title: 'Journey details', route: 'Journey' },
            ],
        },
    },
    {
        path: '/search/:hash/results/:journeyId/print',
        name: 'PrintJourney',
        component: PrintJourney,
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: About,
    },
    {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        component: PrivacyPolicy,
    },
    {
        path: '/hear-more',
        name: 'HearMore',
        component: HearMore,
    },
    {
        path: '/terms-and-conditions',
        name: 'TermsConditions',
        component: TermsConditions,
    },
    {
        path: '/contact-us',
        name: 'Contact',
        component: Contact,
    },
    {
        path: '/cookie-policy',
        name: 'Cookie',
        component: Cookie,
    },
    {
        path: '/site-map',
        name: 'SiteMap',
        component: SiteMap,
    },
    {
        path: '/statement',
        name: 'Statement',
        component: Statement,
    },
]

const userAccountRoutes = [
    {
        path: '/register',
        name: 'Register',
        component: Register,
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
    },
    {
        path: '/account',
        name: 'Account',
        component: UserAccount,
    },
    {
        path: '/edit-account',
        name: 'Edit',
        component: EditAccount,
    },
    {
        path: '/reset-password',
        name: 'Reset',
        component: Reset,
    },
    {
        path: '/auth/activation',
        name: 'Activate Account',
        component: ActivateAccount,

    },
    {
        path: '/auth/password-reset',
        name: 'Change Password',
        component: ChangePassword,

    },
    {
        path: '/searches',
        name: 'Searches',
        component: UserRecentSearches,

    },

]

const routes = whitelabel.enableUserAccounts ? defaultRoutes.concat(userAccountRoutes) : defaultRoutes

const router = new VueRouter({
    routes,
    mode: 'history',
});
/* Make sure the page loads at the top */
router.afterEach(() => {
    window.scrollTo(0, 0)
})

router.beforeEach(TMiddleware)
router.beforeEach(JourneyViewedMiddleware)

export default router;
